import script from "./GmxChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxChart.vue?vue&type=script&setup=true&lang=js"

import "./GmxChart.vue?vue&type=style&index=0&id=9b005eb8&lang=css"

const __exports__ = script;

export default __exports__